module.exports = __webpack_public_path__ + "f36b913d8eb991e2ade06a7d8eb37958.png";